import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';

import { DynamicLayoutComponent } from '../../component/dynamic-layout-component';

import type { LayoutProps } from './layout-types';

const styles = cssMap({
	rowStyle: {
		width: '100%',
	},
});

const REQUIRED_ELEMENTS_COUNT = 1;

export const TwoRowLayout = ({ elements, key, isFoldable = false }: LayoutProps): React.JSX.Element | null => {
	if (elements.length < REQUIRED_ELEMENTS_COUNT) {
		return null;
	}

	return (
		<Stack xcss={styles.rowStyle} space="space.100">
			<Box xcss={styles.rowStyle}>
				{elements.map(
					(element, index) =>
						typeof element !== 'string' &&
						(element.attributes?.pos === 'top' || (index === 0 && !element.attributes?.pos)) && (
							<DynamicLayoutComponent
								component={element}
								position="two-rows-top"
								key={`${key}-${element.attributes?.pos || index}`}
								isFoldable={isFoldable}
							/>
						),
				)}
			</Box>
			<Box xcss={styles.rowStyle}>
				{elements.map(
					(element, index) =>
						typeof element !== 'string' &&
						(element.attributes?.pos === 'bottom' || (index === 1 && !element.attributes?.pos)) && (
							<DynamicLayoutComponent
								component={element}
								position="two-rows-bottom"
								key={`${key}-${element.attributes?.pos || index}`}
								isFoldable={isFoldable}
							/>
						),
				)}
			</Box>
		</Stack>
	);
};
